export default "/assets/profile.svg";